const ReviewPage = () => {
    return <main className="w-full h-full">
        <div className="left-arrow"></div>
        <div className="content w-full h-full">
        <h1 className="text-gray-400">Will make it later</h1>
        </div>
    </main>
}

export default ReviewPage;